<template>
  <MSiteClosed v-if="globalStore.isSiteClosed"/>
  <RouterView v-else v-slot="{ Component }">
    <MDefaultLayout v-if="!route.meta.withoutDefaultLayout">
      <component :is="Component" :key="route.path" />
    </MDefaultLayout>
    <component v-else :is="Component" :key="route.path" />
  </RouterView>
  <MOpenInAppPrompt />
</template>
<script setup>
import MDefaultLayout
  from '@marso2/frontend-shared-components/src/components/pages/MDefaultLayout/index.js';
import { useRoute } from 'vue-router';
import { useGlobalStore } from '@marso2/frontend-shared-components/src/stores/global.js';
import MSiteClosed
  from '@marso2/frontend-shared-components/src/components/pages/MSiteClosed/index.js';
import MOpenInAppPrompt from '@/components/MOpenInAppPrompt.vue';
import { onMounted, watch } from 'vue'

const route = useRoute();
const globalStore = useGlobalStore();

onMounted(() => {
  if (globalStore.isSiteClosed && document) document.title = 'MARSO - Технические работы';
});

watch(() => globalStore.isSiteClosed, async (newValue) => {
  if (newValue && document) document.title = 'MARSO - Технические работы';
}, {immediate: true});
</script>
